import { Modal } from "@twinkltech/curriculum-architect-component-library";
import { Button, IconCommunicationInformation, Text } from "@twinkltech/web-ui";
import { useTranslation } from "react-i18next";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";

import { VIEW_CUSTOM_UNIT_NS } from "./ViewCustomUnitModal.i18n";

export const ViewCustomUnitModal = ({
  customUnit,
  onClose,
  open,
}: {
  open: boolean;
  onClose: () => void;
  customUnit: {
    title: string;
    description?: string;
    cohort: string;
    startOnColumn: string;
    endOnColumn: string;
  };
}) => {
  const { t } = useTranslation(VIEW_CUSTOM_UNIT_NS);
  return (
    <Modal open={open} width="md" onClose={onClose}>
      <Modal.Header className="px-10!">
        <Modal.Title>{t("headings.title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-10! max-h-[75vh] overflow-y-auto">
        <>
          <div className="mb-400">
            <Text as="h3" variant="base-medium">
              {t("headings.unit-title")}
            </Text>
            <Text as="p" className="m-0!">
              {customUnit.title}
            </Text>
          </div>

          <div className="mb-400">
            <Text as="h3" variant="base-medium">
              {t("headings.unit-description")}
            </Text>
            {customUnit.description ? (
              <div className="prose-richtext">
                <Markdown remarkPlugins={[remarkGfm]}>
                  {customUnit.description}
                </Markdown>
              </div>
            ) : (
              <Text as="p" className="m-0! italic text-gray-500">
                {t("no-description")}
              </Text>
            )}
          </div>

          <div className="mb-400">
            <Text as="h3" variant="base-medium">
              {t("headings.cohort")}
            </Text>
            <Text as="p" className="m-0!">
              {customUnit.cohort}
            </Text>
          </div>

          <div className="mb-400">
            <Text as="h3" variant="base-medium">
              {t("headings.start")}
            </Text>
            <Text as="p" className="m-0!">
              {customUnit.startOnColumn}
            </Text>
          </div>

          <div className="mb-400">
            <Text as="h3" variant="base-medium">
              {t("headings.finish")}
            </Text>
            <Text as="p" className="m-0!">
              {customUnit.endOnColumn}
            </Text>
          </div>
        </>

        <div className="flex items-center gap-4 bg-neutral-100 p-200 rounded-md">
          <IconCommunicationInformation className="w-10" />
          <Text as="p" className="m-0! leading-tight" variant="base-medium">
            {t("edit")}
          </Text>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="mt-6 flex justify-end pb-5">
          <Button variant="primary" onClick={onClose}>
            {t("actions.close")}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
